import { MessagesSquare } from 'lucide-react'
import {
  DiscordIcon,
  SlackIcon,
  TelegramIcon,
  TeamsIcon,
  WhatsAppIcon,
} from '@/frontend/components/DigitalWorkers/channelIcons'

interface Props {
  channel: string
}

export default function UsageChannelIcon({ channel }: Props) {
  const normalized = channel.toLowerCase()

  if (normalized.includes('whatsapp')) return <WhatsAppIcon />
  if (normalized.includes('slack')) return <SlackIcon />
  if (normalized.includes('telegram')) return <TelegramIcon />
  if (normalized.includes('discord')) return <DiscordIcon />
  if (normalized.includes('teams')) return <TeamsIcon />
  if (
    normalized.includes('workstation') ||
    normalized.includes('webchat') ||
    normalized.includes('messagechat')
  ) {
    return <img src="/images/stationzero-circle.svg" alt="" className="size-3" aria-hidden="true" />
  }

  return <MessagesSquare className="size-3 text-muted-foreground" strokeWidth={1.8} />
}
